<template>
  <section>
    <div class="flex items-start">
      <div class="relative bg-gray-100 w-[160px] h-[160px]">
        <figure class="w-full h-full">
          <img :src="listing.thumbUrl" :alt="listing.title" class="w-full h-full" />
        </figure>
        <div class="absolute top-0 left-0 w-full h-full" :class="frameClass"></div>
        <div class="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center">
          <div class="scale-[0.8]"><Favourite :listing="listing" :guestFavourites="guestFavourites" /></div>
        </div>
      </div>

      <div class="flex-1 ml-6 mt-3 overflow-x-hidden" :class="{ 'justify-between': cart.discountApplied }">
        <div class="flex">
          <div class="CartItem_details flex-1 overflow-x-hidden">
            <a :href="listing.path" class="text-inherit">
              <h1 class="text-sm truncate">
                {{ listing.title | truncate(30, "...") }}
              </h1>
            </a>
            <p class="mt-1 text-sm text-zinc-400 truncate">
              {{ listing.artist.name }}
            </p>
          </div>
        </div>

        <div class="my-1 text-sm">{{ listing.dimensions }}</div>

        <div class="mt-4 sm:flex sm:items-center">
          <span class="inline-block mr-2.5 font-bold text-sm text-zinc-900">
            {{ item.totalWithDiscounts.format }}
          </span>
          <div class="inline-block text-grey-darker whitespace-nowrap" v-if="item.frame">
            (incl.
            {{ item.frame.price.format }}
            {{ frameOptionName }})
          </div>

          <div class="sm:ml-3 mt-2 sm:mt-0 text-xs" v-if="item.total.cents != item.totalWithDiscounts.cents">
            <span class="line-through text-red-600 mr-4">{{ item.total.format }}</span>
            <span class="bg-red-600 text-white font-bold px-2 py-1 rounded-md">
              {{ item.listing.discountPercentage | discountLabel }}
            </span>
          </div>
        </div>

        <div class="text-bt-blue-500 text-xxs" v-if="item.listing.commissioned">
          Discounts do not apply for commissions
        </div>

        <div class="mt-5">
          <RemoveAddon v-if="item.frame && !listing.reprint" :listing="item.listing" v-slot="{ removeAddon }">
            <button
              type="button"
              @click.prevent="removeAddon"
              class="my-1 flex items-baseline space-x-2.5 pt-0.5 pb-2 px-5 text-xs rounded-full text-white bg-zinc-500"
            >
              <span class="text-base">&ndash;</span>
              <span>Remove Frame</span>
            </button>
          </RemoveAddon>
          <AppendAddon
            v-else-if="item.listing.availableForFraming && !listing.reprint"
            :listing="item.listing"
            v-slot="{ appendAddon }"
          >
            <button
              type="button"
              @click.prevent="appendAddon(defaultAddonOption)"
              class="my-1 flex items-baseline space-x-2.5 pt-0.5 pb-2 px-5 text-xs rounded-full text-zinc-700 bg-zinc-200"
            >
              <span class="text-base">+</span>
              <span>Add Frame</span>
            </button>
          </AppendAddon>
        </div>
      </div>

      <div class="ml-4 flex justify-end">
        <RemoveItem :id="item.id" />
      </div>
    </div>

    <p class="mt-1 text-xs text-grey-dark" v-if="2023 == 2024">
      Delivery from {{ listing.artist.state }}
      <EstimatedShipping :item="item" :artist="listing.artist" />
    </p>
  </section>
</template>

<script>
import AppendAddon from "@/components/Cart/AppendAddon"
import RemoveAddon from "@/components/Cart/RemoveAddon"
import EstimatedShipping from "./EstimatedShipping.vue"
import RemoveItem from "./RemoveItem.vue"
import optionMixin from "@/lib/Framing/OptionToNameMixin"
import Favourite from "@/components/Listing/Favourite.vue"

export default {
  name: "Cart.Nav.Item",
  mixins: [optionMixin],
  props: {
    item: {
      required: true,
      type: Object,
    },
    listing: {
      required: true,
      type: Object,
    },
    cart: {
      required: true,
      type: Object,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  computed: {
    defaultAddonOption() {
      let option = "natural"

      if (this.listing.material === "paper") {
        option += ".matte"
      }

      return option
    },
    frameClass() {
      if (!this.item.frame) return "border-[5px] border-transparent"

      const frameBorderColors = {
        natural: "border-[#DFC2A1]",
        black: "border-black",
        white: "border-gray-50",
      }

      return `border-[5px] ${frameBorderColors[this.item.frame.option.split(".")[0]]}`
    },
  },
  components: {
    AppendAddon,
    RemoveAddon,
    EstimatedShipping,
    RemoveItem,
    Favourite,
  },
}
</script>
